import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button'

import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'

import DialogTitle from '@mui/material/DialogTitle'

import ComboBox from 'Components/ComboBox'
import { Input } from 'Components/Input'
import { useForm } from 'react-hook-form'
import { makePostRequest, makePutRequest } from 'utils/api'

import { convertToMuiDate } from 'utils/helpers'

export default function EditOperationForm({
  params,
  setSelected,
  fetchOperations,
  jobList,
  typeactivite,
  selectedCopy,
  setSelectedCopy,
}) {
  const [selectedType, setSelectedType] = useState(null)
  const [selectedJob, setSelectedJob] = useState(null)

  const [open, setOpen] = useState(true)

  useEffect(() => {
    let job = jobList.find((e) => e.id === params[0].job_id)
    let stype = typeactivite.find((e) => e.label === params[0].activity_type)
    setSelectedJob(job)
    setSelectedType(stype)
    setValue('job_id', job)
    setValue('activity_type', stype)
  }, [])

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      id: params[0].id,
      date: params[0].date ? convertToMuiDate(params[0].date) : '',
      activity_type: selectedType,
      job_id: selectedJob,
      start_time: params[0].start_time ? params[0].start_time : '',
      end_time: params[0].end_time ? params[0].end_time : '',
      total_hours: params[0].total_hours ? params[0].total_hours : '',
    },
  })

  const handleClose = () => {
    setOpen(false)
    setSelected(false)
    setSelectedCopy(false)
  }

  const onSubmit = async (data) => {
    let payload = { ...data, job_id: data.job_id.id, activity_type: data.activity_type.label }

    if (selectedCopy) {
      const response = await makePostRequest(
        '/api/Professional/workentrie-operations/',

        payload,
        {},
        true,
      )
      if (response.status === 201) {
        fetchOperations()
        handleClose()
      }
    } else {
      const response = await makePutRequest(
        '/api/Professional/workentrie-operations/' + data.id + '/',

        payload,
        {},
        true,
      )
      if (response.status === 200) {
        fetchOperations()
        handleClose()
      }
    }
  }

  return (
    <>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'black !important' }}>
          {selectedCopy ? 'Copier Opération' : 'Éditer Opération'}
        </DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: true,
                size: 'small',
                type: 'date',
              }}
              InputLabelProps={{ shrink: true }}
              rules={{ required: true }}
              name="date"
              label="Date"
            />
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('activity_type', j)
                setSelectedType(j)
              }}
              label="Type d’activité"
              data={typeactivite}
              name="activity_type"
              required={true}
              selectedValue={selectedType}
            />
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('job_id', j)
                setSelectedJob(j)
              }}
              label="Fonction"
              data={jobList}
              name="job_id"
              required={true}
              selectedValue={selectedJob}
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                // required: true,
                size: 'small',
                type: 'time',
              }}
              InputLabelProps={{ shrink: true }}
              // rules={{ required: true }}
              name="start_time"
              label="Heure de début "
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                // required: false,
                size: 'small',
                type: 'time',
              }}
              InputLabelProps={{ shrink: true }}
              // rules={{ required: false }}
              name="end_time"
              label="Heure de fin "
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: false,
                size: 'small',
                type: 'number',
              }}
              rules={{ required: false }}
              name="total_hours"
              label="Total in hours"
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
